import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "rows", "placeholder", "disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'UiTextarea',
  props: {
    modelValue: {},
    placeholder: {},
    rows: {},
    disabled: { type: Boolean },
    error: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const handleInput = (event: Event) => {
  if (event.target instanceof HTMLTextAreaElement) emit('update:modelValue', event.target.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    value: _ctx.modelValue,
    rows: _ctx.rows,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    class: _normalizeClass(["text-gray-90 disabled:bg-gray-20 disabled:border-gray-20 disabled:placeholder-gray-60 focus:shadow-input-focus focus:border-active-primary min-w-[216px] rounded border p-2 text-sm placeholder-gray-50 focus:outline-0", [
      _ctx.error ? 'bg-red-10 border-red-40 focus:shadow-input-error focus:border-red-50' : 'bg-gray-10 border-gray-30',
    ]]),
    onInput: handleInput
  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})